<template>
  <div>
    <label for="double-input-confirm"> {{ labelText }} </label>
    <FormInput
      v-model="input"
      :placeholder="inputPlaceholder"
      type="text"
      name="double-input-confirm"
    />
    <button :disabled="disabled" class="btn btn-danger btn-icon w-100" type="submit">
      <div class="icon i-lg icon-trash"></div>
      <span class="pl-2"> {{ buttonText }} </span>
    </button>
  </div>
</template>

<script>
import FormInput from "./FormInput";

export default {
  name: "DoubleConfirmInput",
  components: {
    FormInput,
  },
  props: {
    expectedInput: {
      type: String,
      required: true,
    },
    inputPlaceholder: {
      type: String,
      required: true,
    },
    buttonText: {
      type: String,
      required: true,
    },
    labelText: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      input: "",
    };
  },
  computed: {
    disabled() {
      return this.input !== this.expectedInput;
    },
  },
};
</script>
